import React, { Component } from 'react';

import Tab from "../../../components/admin/etc/tab";

import IDetail from "../../../components/admin/import/detail";

import { getParams, pushUrl } from '../../../utils/functions'

class ImportDetail extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <IDetail />
    )
  }
}

export default ImportDetail